/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { greenApiWebhookRequestSchema } from "./greenApiWebhookRequestSchema.ts";
import { greenApiWebhookSchema } from "./greenApiWebhookSchema.ts";

export const orgGreenApiWebhookNotifyMessageReceivedCreateStatus200Schema = greenApiWebhookSchema;

export const orgGreenApiWebhookNotifyMessageReceivedCreateResponseSchema = orgGreenApiWebhookNotifyMessageReceivedCreateStatus200Schema;

export const orgGreenApiWebhookNotifyMessageReceivedCreateDataSchemaJson = greenApiWebhookRequestSchema;

export const orgGreenApiWebhookNotifyMessageReceivedCreateDataSchemaXml = greenApiWebhookRequestSchema;

export const orgGreenApiWebhookNotifyMessageReceivedCreateDataSchema = z.union([
	orgGreenApiWebhookNotifyMessageReceivedCreateDataSchemaJson,
	orgGreenApiWebhookNotifyMessageReceivedCreateDataSchemaXml,
]);
